import { render, staticRenderFns } from "./JoinUs.vue?vue&type=template&id=5b561afa"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"
import style0 from "./JoinUs.vue?vue&type=style&index=0&id=5b561afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports